/* eslint-disable no-param-reassign */
class SearchForm {
	constructor() {
		this.container = document.getElementById("search");
		this.toggles = document.querySelectorAll('[aria-controls="search"]');
		this.searchRecommendationBlocks = this.container.querySelectorAll("[data-search-recommendation-block]");
		this.searchRecommendationItemTemplate = document.getElementById("search-recommendation-item-template");
		this.searchForm = this.container.querySelector("[data-search-form]");
		this.searchBar = this.searchForm.querySelector('input[name="search"]');
		this.init();
	}

	toggleSearch() {
		const isExpanded = this.container.getAttribute("aria-expanded") === "true";
		if (isExpanded) {
			this.container.setAttribute("aria-expanded", "false");
			document.body.classList.remove("overflow-hidden");
			setTimeout(() => {
				this.container.classList.add("invisible");
			}, 300);
		} else {
			this.container.classList.remove("invisible");
			this.container.setAttribute("aria-expanded", "true");
			document.body.classList.add("overflow-hidden");
			const formInput = this.container.querySelector("input");
			if (formInput) formInput.focus();
		}
	}

	handleToggles() {
		this.toggles.forEach((toggle) => toggle.addEventListener("click", this.toggleSearch.bind(this)));
	}

	static getBlockData(title) {
		if (title !== "Recent") return false;

		const resentSearches = JSON.parse(localStorage.getItem("recentSearches") || "[]");
		return resentSearches.map((s) => ({ label: s.query, count: s.count })).slice(0, 5);
	}

	renderSearchRecommendationBlocks() {
		// clean first
		this.searchRecommendationBlocks.forEach((block) => {
			// eslint-disable-next-line no-param-reassign
			block.innerHTML = "";
		});

		this.searchRecommendationBlocks.forEach((block) => {
			const title = block.dataset.searchRecommendationBlock;
			const blockData = SearchForm.getBlockData(title);
			if (!blockData) {
				block.parentNode.innerHTML = "";
				return;
			}
			blockData.forEach((item) => {
				const node = this.searchRecommendationItemTemplate.content.cloneNode(true);
				const labelEle = node.querySelector("[data-label]");
				if (labelEle) labelEle.innerText = item.label;

				const countEle = node.querySelector("[data-count]");
				if (countEle) countEle.innerText = item.count;

				const buttonEle = node.querySelector("[data-button]");
				if (buttonEle) {
					buttonEle.addEventListener("click", () => {
						this.searchBar.value = item.label;
						this.searchForm.requestSubmit();
					});
				}

				block.appendChild(node);
			});
		});
	}

	handleForm() {
		this.searchForm.addEventListener("submit", (e) => {
			e.preventDefault();
			const formData = new FormData(e.target);
			const searchValue = formData.get("search");
			if (!searchValue) return;

			window.location.href = `/search/?q=${searchValue}`;
		});
	}

	init() {
		this.renderSearchRecommendationBlocks();
		this.handleForm();
		this.handleToggles();
	}
}

// eslint-disable-next-line no-new
window.searchForm = new SearchForm();
